const defaults = {
  showSidebar: false,
  selectedWeighInIndex: 0,
  showCoachingModal: false,
  showGetStartedModal: false,
  showWeighInModal: false,
  showResetWeighInModal: false,
  showGoalWeighInModal: false,
  showActivityWeighInModal: false,
  showCaloriesWeighInModal: false,
  showEditWeighInModal: false,
  showEditCheckWeighInModal: false,
  showEditAddWeighInModal: false,
  showResumeWeighInModal: false,
  showStartWeighInModal: false,
  showNotificationModal: false,
  showPart7Modal: false,
  showCarryOverModal: false,
  showCarryOverWithReasonModal: false,
  carryOverReportDateString: '',
  carryOverQuestion: '',
  reasonsMask: 0,
  showBfCalcModal: false,
  showBillingModal: false,
  showPortalConsentModal: false,
  showDailyWeightModal: false,
  selectedDailyWeight: '',
  showEditDailyWeightsModal: false,
  showDailyWeightNeededModal: false,
  resumeGoalChangeMode: false,
  snackbar_State: false,
  snackbar_Message: "",
  snackbar_HideTime: 2000,
  snackbar_Type: 'success',
  showAddItemModal: false,
  showAddIngredientsModal: false,
  editScreenAddIngredient: false,
  editScreenSwapIngredient: false,
  editScreenSwapIndex: 0,
  addItemCategory: 'breakfast',
  addItemFavoritesCategory: 'food',
  currentRecipe: {},
  coaching: {},
  notification: {},
  showEditNowModal: false,
  editNowModalType: '',
  showTargetReached: false, // Only displays when allow and show are true
  targetReachedMessageId: 0,
  friendsTab: 'friends',
  unreadChannels: '',
}

export default (state = defaults, action) => {
  switch (action.type) {
    case 'SHOW_SIDEBAR':
      state = { ...state, showSidebar: action.payload.showSidebar }
      break;
    case 'SET_SNACKBAR':
      state = { ...state, snackbar_State: action.payload.snackbar_State,
        snackbar_Message: action.payload.snackbar_Message,
        snackbar_HideTime: action.payload.snackbar_HideTime,
        snackbar_Type: action.payload.snackbar_Type }
      break;
    case 'SET_FAVORITES_CATEGORY':
        state = { ...state, ...action.payload }
        break;
    case 'SHOW_ADD_ITEM_MODAL':
      state = { ...state, ...action.payload }
      break;
    case 'SHOW_ADD_INGREDIENTS_MODAL':
      state = { ...state, ...action.payload }
      break;
    case 'EDIT_SCREEN_UPDATE_ADD_INGREDIENT':
      state = { ...state, ...action.payload }
      break;
    case 'SET_ADD_ITEM_CATEGORY':
      state = { ...state, ...action.payload }
      break;
    case 'COMPLETE_GUIDE':
      state = { ...state, ...action.payload }
      break;
    case 'SHOW_SNACKBAR':
      state = { ...state, snackbar_State: action.payload.snackbar_State }
      break;
    case 'SHOW_MODAL':
      state = { ...state, ...action.payload }
      break;
    case 'SHOW_EDIT_WEIGHIN_MODAL':
      state = { ...state, ...action.payload }
      break;
    case 'SHOW_EDITADD_WEIGHIN_MODAL':
      state = { ...state, ...action.payload }
      break;
    case 'SHOW_EDITCHECK_WEIGHIN_MODAL':
      state = { ...state, ...action.payload }
      break;
    case 'SHOW_BF_CALC_MODAL':
      state = { ...state, ...action.payload }
      break;
    case 'SHOW_BILLING_MODAL':
      state = { ...state, ...action.payload }
      break;
    case 'SHOW_PORTAL_CONSENT_MODAL':
      state = { ...state, ...action.payload }
      break;
    case 'ADD_RESET_WEIGHIN_FULFILLED':
      state = { ...state, showCoachingModal: true, coachingMessage: action.payload?.coaching?.description, coaching: action.payload.coaching }
      break;
    case 'WEIGH_IN_FULFILLED':
      let weighInCoachingMessage = action.payload.coaching?.description
      if(action.payload.coaching?.follow_up_modal) {
        if(action.payload.coaching?.follow_up_modal === 'goal-change-requested') {
          weighInCoachingMessage += ' If you still want to change your goal you can do that now!'
        } else if(action.payload.coaching?.follow_up_modal === 'activity-level-change-requested') {
          weighInCoachingMessage += ' If you still want to change your activity levels you can do that now!'
        }
      }
      if(action.payload.keepable) {
        state = { ...state,
          showWeighInModal: false,
          showCarryOverModal: true,
          carryOverReportDateString: action.payload.report_date,
          coaching: action.payload.coaching,
          coachingMessage: weighInCoachingMessage,
          carryOverQuestion: action.payload.carry_over_question,
          reasonsMask: action.payload.coaching.reasons_mask
        }
      } else {
        state = { ...state,
          showWeighInModal: false,
          showNotificationModal: true,
          // notificationHeader: 'Coaching Mode',
          // notificationMessage: weighInCoachingMessage,
          notification: action.payload.coaching
        }
      }
      break;
    case 'WEIGH_IN_REJECTED':
      state = { ...state, error: action.payload.coaching?.description }
      break;
    case 'WEIGH_IN_AND_MODIFY_USER_FULFILLED':
      state = { ...state,
        showGoalWeighInModal: false,
        showActivityWeighInModal: false,
        showCaloriesWeighInModal: false,
        showNotificationModal: true,
        // notificationHeader: 'Coaching Mode',
        // notificationMessage: action.payload.coaching.description,
        notification: action.payload.coaching
      }
      break;
    case 'EDIT_WEIGH_IN_FULFILLED':
      state = { ...state, showEditWeighInModal: false }
      break;
    case 'KEEP_TARGETS_FULFILLED':
      state = { ...state, showCarryOverModal: false }
      break;
    case 'KEEP_TARGETS_WITH_REASON_FULFILLED':
      state = { ...state, showCarryOverWithReasonModal: false }
      break;
    case 'EDITADD_WEIGH_IN_FULFILLED':
      state = { ...state,
        showNotificationModal: true,
        // notificationMessage: action.payload.message,
        // notificationHeader: 'Coaching Mode',
        notification: action.payload.coaching
      }
      break;
    case 'EDITADD_WEIGH_IN_FULFILLED_NO_COACH':
      state = { ...state }
      break;
    case 'RESUME_FULFILLED':
      state = { ...state,
        showResumeWeighInModal: false,
        showNotificationModal: true,
        // notificationMessage: (action.payload.coaching.description) ? action.payload.coaching.description : 'Welcome back!',
        // notificationHeader: 'Coaching Mode',
        notification: action.payload.coaching
      }
      break;
    case 'DISPLAY_NOTIFICATION_MESSAGE':
        state = { ...state,
          showNotificationModal: true,
          // notificationMessage: action.payload.message,
          // notificationHeader: action.payload.header,
          notification: action.payload.coaching
        }
        break;
    case 'DISPLAY_PART7_MESSAGE':
        state = { ...state,
          showPart7Modal: true,
          part7Message: action.payload.message
        }
        break;
    case 'ENABLE_RESUME_GOAL_CHANGE_MODE':
      state = { ...state, ...action.payload }
      break;
    case 'SHOW_EDIT_NOW_MODAL':
      state = { ...state, ...action.payload }
      break;
    case 'SHOW_TARGET_REACHED_MODAL':
      state = { ...state, ...action.payload }
      break;
    case 'UPDATE_DASHBOARD_STORE':
      state = { ...state, ...action.payload }
      break;
    case 'CREATE_USER_FULFILLED':
      // 8/22/18 - Deprecated for WhatFix requirement
      // state = { ...state,
      //   showNotificationModal: true,
      //   notificationMessage: action.payload.data.message,
      //   notificationHeader: 'Coaching Mode'
      // }
      break;
    case 'UPDATE_SELECTED_DAILYWEIGHT':
      state = { ...state, ...action.payload }
      break;
    default: // Do nothing
  }

  return state;
};
